import { Input, InputProps } from '@e2n/ui';
import { maskitoUpdateElement } from '@maskito/core';
import { maskitoTimeOptionsGenerator, maskitoEventHandler } from '@maskito/kit';
import { useMaskito } from '@maskito/react';

const timeOptions = maskitoTimeOptionsGenerator({
  mode: 'HH:MM',
  timeSegmentMaxValues: { hours: 23 },
});
const options = {
  ...timeOptions,
  plugins: [
    ...timeOptions.plugins,
    maskitoEventHandler('blur', (element) => {
      const [hours = '', minutes = ''] = element.value.split(':');
      if (hours === '' && minutes === '') return;
      maskitoUpdateElement(
        element,
        [hours, minutes].map((segment) => segment.padEnd(2, '0')).join(':'),
      );
    }),
  ],
};

export function TimeInput({
  className,
  value,
  onChange,
  ...props
}: InputProps) {
  const maskito = useMaskito({ options });

  return (
    <Input
      inputMode="numeric"
      {...props}
      ref={maskito}
      className={`text-start md:text-center h-10 ${className ?? ''}`}
      value={value}
      onChange={onChange}
      placeholder={props.placeholder ?? '--:--'}
      type="text"
    />
  );
}
